import { Avatar, AvatarRootProps } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { getAvatarColorsFromName } from '../../utils';

// `name`/`src` aren't part of v3's `AvatarRootProps` (they're specific to
// `Avatar.Fallback`/`Avatar.Image`) — MAvatar accepts both at the root level
// and forwards them to the real sub-components itself.
type MAvatarProps = AvatarRootProps & { name?: string; src?: string };

// Forwards its ref so it can be a `Tooltip` trigger (Ark's `asChild` anchors
// the tooltip through the child's ref).
export const MAvatar = forwardRef<HTMLDivElement, MAvatarProps>(
  ({ name, src, ...rest }, ref) => {
    const { bg, color } = getAvatarColorsFromName(name || '');
    return (
      // v2's `Avatar` derived its accessible name from `name` automatically;
      // v3's `Avatar.Root` doesn't, so it's set explicitly here.
      <Avatar.Root ref={ref} aria-label={name} bg={bg} color={color} {...rest}>
        {src && <Avatar.Image src={src} />}
        <Avatar.Fallback name={name} />
      </Avatar.Root>
    );
  },
);

MAvatar.displayName = 'MAvatar';
